import { NgModule } from '@angular/core';
import {
  DealDataOverridesDialogComponent
} from 'ng2-app/deal-data-overrides-dialog/deal-data-overrides-dialog.component';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { FormlyModule } from '@ngx-formly/core';

@NgModule({
  declarations: [
    DealDataOverridesDialogComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
  ],
  exports: [
    DealDataOverridesDialogComponent,
  ]
})
export class DealDataOverridesDialogModule { }
